const translations = {
  tr: {
    title: 'Kelime Bulucu',
    placeholder: 'Harfleri girin...',
    search: 'Ara',
    searching: 'Aranıyor...',
    enterLetters: 'Lütfen harf girin',
    fetchError: 'Kelimeler getirilemedi',
    invalidResponse: 'Sunucudan geçersiz yanıt formatı',
    foundWords: (count) => `${count} kelime bulundu`,
    lettersLabel: (length, count) => `${length} Harfli (${count})`,
    noResults: 'Kelime bulunamadı. Farklı harfler deneyin!',
    language: 'Dil',
    meaningTitle: 'Kelime anlamı',
    meaningLoading: 'Anlam yükleniyor...',
    meaningError: 'Kelime anlamı getirilemedi',
    noMeaning: 'Bu kelime için anlam bulunamadı.',
    close: 'Kapat',
  },
  en: {
    title: 'Word Generator',
    placeholder: 'Enter letters...',
    search: 'Search',
    searching: 'Searching...',
    enterLetters: 'Please enter some letters',
    fetchError: 'Failed to fetch words',
    invalidResponse: 'Invalid response format from server',
    foundWords: (count) => `Found ${count} words`,
    lettersLabel: (length, count) => `${length} Letters (${count})`,
    noResults: 'No words found. Try different letters!',
    language: 'Language',
    meaningTitle: 'Word meaning',
    meaningLoading: 'Loading meaning...',
    meaningError: 'Failed to fetch word meaning',
    noMeaning: 'No meaning found for this word.',
    close: 'Close',
  },
};

export default translations;
